import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import MarketingNav from '../components/marketing/MarketingNav'
import ApiSection from '../components/marketing/ApiSection'
import FooterSection from '../components/marketing/FooterSection'

/**
 * The API story, off the main page. The visitor the homepage is written for
 * does not have a data person; the one who does comes looking for this.
 */
const DevelopersPage: React.FC = () => (
  <div className="min-h-screen bg-surface">
    <MarketingNav />
    <ApiSection />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
      <Link to="/" className="text-sm text-primary hover:text-primary-dark">
        <FormattedMessage id="marketing.developers.back" />
      </Link>
    </div>
    <FooterSection />
  </div>
)

export default DevelopersPage
